import React from "react";
import Background1 from "../../assets/images/breadcum/01.jpg";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import { Modal, Button } from "react-bootstrap";
export default function NewsandEvents() {
  const [dataDesc, setData] = useState([]);
  const [title, setTitle] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedNews, setSelectedNews] = useState(null);

  const handleClose = () => setShowModal(false);
  const handleShow = (news) => {
    setSelectedNews(news);
    setShowModal(true);
  };
  useEffect(() => {
    const fetchData = async () => {
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_API_URL}/api/auth/get/getallNews`
      );
      console.log("this is news get", res.data);
      // Filter out inactive news items
      const activeNews = res.data.filter((News) => News.IsActive);
      setData(activeNews);
    };
    fetchData();
  }, []);



  return (
    <>
      {/* <!--inner-header --> */}
      <section
        className="inner-banner bg-overlay-black-70 bg-holder"
        style={{ backgroundImage: `url(${Background1})` }}
      >
        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="col-md-12">
              <div className="text-center">
                <h1 className="text-white">News & Events</h1>
              </div>
              <div className="d-flex justify-content-center ">
                <ol className="breadcrumb mb-0 p-0">
                  <li className="breadcrumb-item">
                    <Link to="/">Home</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <a href="#">Media</a>
                  </li>
                  <li className="breadcrumb-item active">
                    <span>News & Events</span>
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!--inner-header --> */}
      {/* <!--Event --> */}
      <section className="news-event-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-12">
              <div className="row">
                {dataDesc.map((data, index) => {
                  return (
                    <div key={index} className="col-lg-12 mt-4">
                      <div className="blog-post d-flex align-items-center shadow border-radius">
                        <div className="blog-contant">
                          <h3 className="mt-0 mb-3">{data.Title}</h3>
                          <ul className="list-unstyled mb-0 d-flex">
                            <li className="mr-3">
                              <i className="fas fa-calendar-alt pr-1"></i>{" "}
                              {data.date.split("T")[0]}
                            </li>
                          </ul>
                          <p style={{ color: "#0160aa !important" }}>{data.Shortdescription}</p>

                          <button
                            className="btn btn-link p-0"
                            onClick={() => handleShow(data)}
                            style={{ textDecoration: 'none', color: '#009639', fontSize: '18px' }}
                          >
                            View Details
                          </button>
                        </div>{" "}
                      </div>{" "}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <!-- Modal --> */}
      {selectedNews && (
        <Modal show={showModal} onHide={handleClose} size="lg" centered>
          <Modal.Header closeButton>
            <Modal.Title style={{ color: '#009639' }}>{selectedNews.Title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="mb-3 text-muted">
              <i className="fas fa-calendar-alt pr-1"></i> {selectedNews.date.split("T")[0]}
            </div>
            <div dangerouslySetInnerHTML={{ __html: selectedNews.Description }} />
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {/* <!--Event --> */}
    </>
  );
}
